import { DEFAULT_IMAGE } from '@/utils/const';

export default {
  props: {
    user: {
      type: Object,
      default: () => {},
    },
    userType: {
      type: String,
      default: 'Proofreader',
    },
  },
  data () {
    return {
      defaultImage: DEFAULT_IMAGE,
    };
  },
};
